class Drawer {
  constructor() {
    this.html = document.querySelector('html');
    this.hamburger = document.querySelector('#hamburger');
    this.close = document.querySelector('#drawer-close');
    this.drawerNavLinks = document.querySelectorAll('.drawer__nav-link, .drawer__cta');

    this.init();
  }

  init() {
    this.bindEvents();
  }

  toggleDrawer = () => {
    this.html.classList.toggle('js-drawer-open');
  };

  bindEvents() {
    if (this.hamburger) {
      this.hamburger.addEventListener('click', this.toggleDrawer);
    }

    if (this.close) {
      this.close.addEventListener('click', this.toggleDrawer);
    }

    this.drawerNavLinks.forEach((item) => {
      item.addEventListener('click', this.toggleDrawer);
    });
  }
}

new Drawer();

class IntersectionAnimator {
  constructor({ selector, onIntersect, options = { root: null, threshold: 0.5 } }) {
    this.elements = document.querySelectorAll(selector);
    this.onIntersect = onIntersect;

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        this.onIntersect(entry, observer);
      });
    }, options);

    this.init();
  }

  init() {
    this.elements.forEach((el) => this.observer.observe(el));
  }
}

new IntersectionAnimator({
  selector: '[data-animate="fadein"]',
  onIntersect: (entry) => {
    const type = entry.target.dataset.animate;

    switch (type) {
      case 'fadein':
        entry.target.classList.add('js-fadein');
        break;
    }
  },
});

class SmoothScroll {
  constructor() {
    this.links = document.querySelectorAll('a[href*="#"]');
    this.header = document.querySelector('header');

    this.init();
  }

  init() {
    this.bindEvents();
  }

  handleClick = (e) => {
    const href = e.currentTarget.getAttribute('href');
    const id = href.replace('#', ''); // ← #削除
    const target = document.getElementById(id);

    if (!target) return;

    e.preventDefault();

    const headerHeight = this.header ? this.header.offsetHeight : 0;
    const targetPos = target.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: targetPos - headerHeight,
      behavior: 'smooth',
    });
  };

  bindEvents() {
    this.links.forEach((el) => {
      el.addEventListener('click', this.handleClick);
    });
  }
}

new SmoothScroll();

// 固定ボタン
try {
  const HTML = document.documentElement;
  const SECTION_FV = document.querySelector('.section-fv');
  const SECTION_CONTACT = document.querySelector('.section-form');

  const onScroll = () => {
    if (!SECTION_FV) return;

    const fvBottom = SECTION_FV.getBoundingClientRect().bottom;
    const contactTop = SECTION_CONTACT ? SECTION_CONTACT.getBoundingClientRect().top : Infinity;

    // FVを抜けた && contactに入ってない
    const isShow = fvBottom <= 0 && contactTop > window.innerHeight;

    HTML.classList.toggle('js-intersecting-fv', isShow);
  };

  window.addEventListener('scroll', onScroll);
  window.addEventListener('load', onScroll); // 初期判定
} catch (error) {
  console.log(error);
}
